import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import StyledDealflowEntityProfileBarWrapper
  from 'components/templates/Wrappers/Dealflow/Entities/DealflowEntityProfileBarWrapper/DealflowEntityProfileBarWrapper.styles';
import DealflowEntityProfileBar from 'components/organisms/Bars/DealflowEntityProfileBar/DealflowEntityProfileBar';

const DealflowEntityProfileBarWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    ToolbarComponent: DealflowEntityProfileBar,
    ...props
  }, 'DealflowEntityProfileBarWrapper');

  const profileProvider = useProfile();

  innerProps.variant = innerProps.variant ?? (
    (profileProvider.state.isEditing || profileProvider.state.showToc) ? 'sticky' : 'inset'
  );

  return <StyledDealflowEntityProfileBarWrapper ref={ref} {...innerProps} collapse={false}>
    {innerProps.children}
  </StyledDealflowEntityProfileBarWrapper>
});

DealflowEntityProfileBarWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntityProfileBarWrapper;
